module.exports = __webpack_public_path__ + "696d698210a2c8d7cc58e511b312adf1.MP3";